/**
 * Base Component
 * 
 * @copyright NIIT Technologies Ltd. 2017-18
 */
// Angular
import {
    Component, Injectable, Inject, ReflectiveInjector, NgZone, ResolvedReflectiveProvider,
    ElementRef, OnInit, OnDestroy, AfterContentInit, AfterViewInit, OnChanges,
    ViewChildren, ContentChildren, QueryList, HostListener, ChangeDetectorRef,
    Input, SimpleChanges, forwardRef, ViewContainerRef, ComponentFactoryResolver, ComponentRef,
    SystemJsNgModuleLoader, Compiler, ModuleWithComponentFactories
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
// Core
import { ContainerComponent } from './container.component';
import { Event, NotificationType, BaseResponse, ErrorMessage } from '../common/base.data';
import { EventService } from '../service/event.service';

/**
 * Application Component
 */
export class ApplicationComponent extends ContainerComponent {

    /**
     * Initialize
     */
    constructor(protected appZone: NgZone,
        protected appElement: ElementRef, protected appContainerElement: ElementRef,
        protected appComponentResolver: ComponentFactoryResolver,
        protected loader: SystemJsNgModuleLoader,
        protected compiler: Compiler) {
        //
        super("APPLICATION", appZone, appElement, null, appComponentResolver);
    }

    /**
     * On Initialization
     */
    public ngOnInit() {
        super.ngOnInit();
    }

    /**
     * On Destroy
     */
    public ngOnDestroy() {
        super.ngOnDestroy();
    }

    /**
     * Load Module @todo
     *
     * 
     * @param modulePath Module Path
     */
    protected loadModule(modulePath: any): void {
        // Load Module & Its Components
        this.loader.load(modulePath.modulePath)
            .then((moduleFactory) => {
                this.compiler.compileModuleAndAllComponentsAsync<any>(moduleFactory.moduleType)
                    .then((factory: ModuleWithComponentFactories<any>) => {
                        return factory.componentFactories.find(x => x.componentType.name === modulePath.componentName);
                    })
                    .then(componentFactory => {
                    });
            });
    }

}